export const removeAuxPartFromParts = (parts: any) =>
	parts.map((p: any) => {
		const { auxParts: _auxParts, ...rest } = p;
		return rest;
	});
